import { render, staticRenderFns } from "./PrescriptionCheck.vue?vue&type=template&id=5ead6ff0&"
import script from "./PrescriptionCheck.vue?vue&type=script&lang=js&"
export * from "./PrescriptionCheck.vue?vue&type=script&lang=js&"
import style0 from "./PrescriptionCheck.vue?vue&type=style&index=0&id=5ead6ff0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports